import { Injectable } from '@angular/core';
import { Workbox } from 'workbox-window';
import { BehaviorSubject } from 'rxjs';
import { first } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class WorkBoxService {
  private wb: Workbox | null = null;
  private version = new BehaviorSubject('');

  constructor(
    private snackbar: MatSnackBar,
    private translateService: TranslateService,
  ) {}

  async getServiceWorkerVersion() {
    if (!this.wb) {
      return;
    }

    this.version.next(await this.wb.messageSW({ type: 'GET_VERSION' }));
  }

  async register() {
    try {
      this.wb = new Workbox('/sw.js');
      this.installed();
      await this.wb.register();
    } catch (error) {
      console.warn('[SW] Service worker registration failed. Continuing without SW.', error);
      this.wb = null;
    }
  }

  private installed() {
    if (!this.wb) {
      return;
    }

    this.wb.addEventListener('installed', (event) => {
      if (!event.isUpdate) {
        return;
      }
      window.location.reload();
    });
  }
}
